import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import { withRouter } from 'react-router';

const LeftNav = (
  {
    postLogout,
    history,
    location
  }
) => {
  const handleLogout = () =>
    postLogout(null, null, null, () => history.push('/'));
  const activeMenuItem = (value, fuzzy) => {
    if (fuzzy) return (location.pathname || '').indexOf(value || '') === 0 ? 'selected' : '';
    return location.pathname === value ? 'selected' : '';
  }
  return (
    <div className="col-filters">
      <div className="d-block d-md-none mobile-filters">
        <Link to="/account" className={activeMenuItem('/account')}>
          Account Details
        </Link>
        <Link
          to="/account/edit-profile"
          className={activeMenuItem('/account/edit-profile', true)}
        >
          Edit Profile
        </Link>
        <Link
          to="/account/my-orders"
          className={activeMenuItem('/account/my-orders')}
        >
          My Orders
        </Link>
        <Link
          to="/account/club-information"
          className={activeMenuItem('/account/club-information')}
        >
          Membership 
        </Link>
        <Link onClick={handleLogout}>Logout</Link>
      </div>
      <div className="d-none d-md-block d-lg-block d-xl-block">
        <div className="account-navigation">
          <Link to="/account" className={activeMenuItem('/account')}>
            Account Details
          </Link>
          <Link
            to="/account/edit-profile"
            className={activeMenuItem('/account/edit-profile', true)}
          >
            Edit Profile
          </Link>
          <Link
            to="/account/my-orders"
            className={activeMenuItem('/account/my-orders')}
          >
            My Orders
          </Link>
          <Link
            to="/account/club-information"
            className={activeMenuItem('/account/club-information')}
          >
            Membership
          </Link>
          <Link onClick={handleLogout}>Logout</Link>
        </div>
      </div>
    </div>
  );
};

const mapState = state => ({});

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postLogout: fetchDux.postLogout.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(withRouter(LeftNav));
